/*
  Air Reviews rendert einige Texte fest auf Englisch — die Karussell-Ueberschrift
  sogar dann, wenn in der App eine deutsche Ueberschrift hinterlegt ist
  ("Unsere Kundenbewertungen" wird nicht verwendet). Solange sich das nicht
  app-seitig loesen laesst, werden die Texte hier im DOM ersetzt.

  Bewusst per JS statt per CSS-::before-Trick: So steht der deutsche Text
  wirklich im DOM und Screenreader lesen nicht zusaetzlich das englische Original.

  Neue Begriffe einfach unten in die Liste aufnehmen.
*/
(function () {
  var ERSETZUNGEN = {
    'See what our customers said': 'Das sagen unsere Kundinnen und Kunden',
    'Write a review': 'Bewertung schreiben',
    'Written by guest': 'Von einem Gast verfasst',
    'All reviews page': 'Alle Bewertungen',
    'Review': 'Bewertungen'
  };

  var laeuft = false;
  var geplant = false;

  function textKnotenErsetzen(wurzel) {
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var knoten;
    while ((knoten = lauf.nextNode())) {
      var roh = knoten.textContent;
      var getrimmt = roh.trim();
      if (getrimmt && Object.prototype.hasOwnProperty.call(ERSETZUNGEN, getrimmt)) {
        knoten.textContent = roh.replace(getrimmt, ERSETZUNGEN[getrimmt]);
      }
    }
  }

  function durchlauf() {
    geplant = false;
    if (laeuft) return;
    laeuft = true;
    try {
      var bereiche = document.querySelectorAll('[class*="AirReviews"]');
      for (var i = 0; i < bereiche.length; i++) textKnotenErsetzen(bereiche[i]);
    } finally {
      laeuft = false;
    }
  }

  function anstossen() {
    if (geplant || laeuft) return;
    geplant = true;
    // Bewusst setTimeout statt requestAnimationFrame: rAF feuert nicht,
    // solange der Tab im Hintergrund ist — dann bliebe der Text englisch.
    setTimeout(durchlauf, 0);
  }

  anstossen();
  document.addEventListener('DOMContentLoaded', anstossen);

  // Das Widget rendert asynchron und baut sich beim Blaettern neu auf.
  new MutationObserver(anstossen).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
